import React, { useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import productData from "../Datas/productData";
import "../css/main.scss";

const HERO_IMAGE = `${process.env.PUBLIC_URL}/main/averlynxstore-hero.png`;
const PUBLIC = process.env.PUBLIC_URL || "";

const TRENDING_ITEMS = [
  {
    src: `${PUBLIC}/img/103-averlynxstore.png`,
    label: "MATCHING SETS",
  },
  {
    src: `${PUBLIC}/img/102-averlynxstore.png`,
    label: "SWEATSHIRTS",
  },
  {
    src: `${PUBLIC}/img/104-averlynxstore.png`,
    label: "SHORTS",
  },
  {
    src: `${PUBLIC}/img/105-averlynxstore.png`,
    label: "BEST SELLERS",
  },
];

const ACTIVITY_ITEMS = [
  { src: `${PUBLIC}/img/108-averlynxstore.png`, label: "PILATES" },
  { src: `${PUBLIC}/img/102a-averlynxstore.png`, label: "LOUNGE" },
  { src: `${PUBLIC}/img/1014-averlynxstore.png`, label: "YOGA" },
  { src: `${PUBLIC}/img/1015-averlynxstore.png`, label: "COURT SPORTS" },
  { src: `${PUBLIC}/img/1013-averlynxstore.png`, label: "TRAIN" },
  { src: `${PUBLIC}/img/1017-averlynxstore.png`, label: "RUN" },
];

const PROMO_SPLIT_ITEMS = [
  {
    image: `${PUBLIC}/main/averlynxstore-travel.png`,
    eyebrow: "TRAVEL IN AVERLYNXSTORE",
    headlineLines: ["Effortless looks for", "every itinerary."],
    cta: "Shop Travel",
    to: "/shop",
  },
  {
    image: `${PUBLIC}/main/averlynxstore-movement.png`,
    eyebrow: "MOST WANTED",
    headlineLines: ["The looks you've seen", "everywhere."],
    cta: "Shop Trending",
    to: "/shop",
  },
];

/** SHOP BY COLOR — 竖图 + 底部色条文案 */
const COLOR_SHOP_ITEMS = [
  {
    src: `${PUBLIC}/img/102b-averlynxstore.png`,
    name: "OATMEAL HEATHER",
    subtitle: null,
    barBg: "#e5e0d8",
  },
  {
    src: `${PUBLIC}/img/1013a-averlynxstore.png`,
    name: "GRAVEL",
    subtitle: null,
    barBg: "#d8d3cc",
  },
  {
    src: `${PUBLIC}/img/1018a-averlynxstore.png`,
    name: "VINTAGE PINK",
    subtitle: "New color throwback vibe",
    barBg: "#f5d0dc",
  },
  {
    src: `${PUBLIC}/img/106a-averlynxstore.png`,
    name: "OLIVE TREE",
    subtitle: "This elevated neutral has the perfect undertone.",
    barBg: "#c9bfb2",
  },
  {
    src: `${PUBLIC}/img/109a-averlynxstore.png`,
    name: "PLUM KISS",
    subtitle: null,
    barBg: "#d2c2d6",
  },
];

const STYLED_BY_YOU_ITEMS = [
  {
    src: `${PUBLIC}/img/101b-averlynxstore.png`,
    user: "AVERLYNXSTORE COMMUNITY",
    spots: [
      { t: 36, l: 32 },
      { t: 58, l: 48 },
    ],
  },
  {
    src: `${PUBLIC}/img/104b-averlynxstore.png`,
    user: "AVERLYNXSTORE COMMUNITY",
    spots: [
      { t: 34, l: 38 },
      { t: 52, l: 42 },
      { t: 70, l: 58 },
    ],
  },
  {
    src: `${PUBLIC}/img/1015b-averlynxstore.png`,
    user: "AVERLYNXSTORE COMMUNITY",
    spots: [
      { t: 40, l: 52 },
      { t: 66, l: 50 },
    ],
  },
  {
    src: `${PUBLIC}/img/1019b-averlynxstore.png`,
    user: "AVERLYNXSTORE COMMUNITY",
    spots: [{ t: 44, l: 45 }],
  },
];

function formatGbp(price) {
  const n = Number(price);
  if (Number.isNaN(n)) return price;
  return n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2);
}

function Main() {
  const finishingTrackRef = useRef(null);
  const colorTrackRef = useRef(null);
  const styledTrackRef = useRef(null);

  const scrollFinishingNext = useCallback(() => {
    const el = finishingTrackRef.current;
    if (!el) return;
    const card = el.querySelector(".main-finishing__card");
    const gap = 18;
    const step = card ? card.offsetWidth + gap : 240;
    el.scrollBy({ left: step, behavior: "smooth" });
  }, []);

  const toTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="main">
      <Header />

      <main>
        <section
          className="main-hero"
          aria-label="Featured collection"
          style={{
            backgroundImage: `url(${HERO_IMAGE})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="main-hero__inner">
            <div className="main-hero__grid">
              <div className="main-hero__col main-hero__col--right">
                <Link onClick={toTop} to="/shop" className="main-hero__cta">
                  SHOP NEW IN
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* 2 */}
        <section
          className="main-trending"
          aria-labelledby="main-trending-heading"
        >
          <div className="main-trending__inner">
            <h2 id="main-trending-heading" className="main-trending__title">
              TRENDING NOW
            </h2>
            <ul className="main-trending__grid">
              {TRENDING_ITEMS.map((item) => (
                <li key={item.label} className="main-trending__cell">
                  <Link
                    onClick={toTop}
                    to="/shop"
                    className="main-trending__card"
                  >
                    <div className="main-trending__thumb">
                      <img
                        src={item.src}
                        alt=""
                        className="main-trending__img"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <span className="main-trending__label">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* 3 */}
        <section
          className="main-hero"
          aria-label="Featured collection"
          style={{
            backgroundImage: `url("/main/averlynxstore-movement.png")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="main-hero__inner">
            <div className="main-hero__grid">
              <div className="main-hero__col main-hero__col--right">
                <Link onClick={toTop} to="/shop" className="main-hero__cta">
                  SHOP ALMOST GONE
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* 4 */}
        <section
          className="main-finishing"
          aria-labelledby="main-finishing-heading"
        >
          <div className="main-finishing__inner">
            <div className="main-finishing__head">
              <h2 id="main-finishing-heading" className="main-finishing__title">
                FINISHING TOUCHES
              </h2>
              <Link
                onClick={toTop}
                to="/shop"
                className="main-finishing__shop-link"
              >
                Shop All
              </Link>
            </div>
            <div className="main-finishing__viewport">
              <div
                ref={finishingTrackRef}
                className="main-finishing__track"
                tabIndex={0}
              >
                {productData.map((p) => (
                  <article key={p.id} className="main-finishing__card">
                    <Link
                      onClick={toTop}
                      to={`/shopDetails/${p.id}`}
                      className="main-finishing__card-link"
                    >
                      <div className="main-finishing__img-wrap">
                        <img
                          src={p.image}
                          alt={p.name}
                          className="main-finishing__img"
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                      <p className="main-finishing__name">{p.name}</p>
                      <p className="main-finishing__price">
                        ${formatGbp(p.price)}
                      </p>
                    </Link>
                  </article>
                ))}
              </div>
              <button
                type="button"
                className="main-finishing__next"
                onClick={scrollFinishingNext}
                aria-label="Scroll products right"
              >
                ›
              </button>
            </div>
          </div>
        </section>

        {/* 4-1 */}
        <section
          className="main-activity"
          aria-labelledby="main-activity-heading"
        >
          <div className="main-activity__inner">
            <h2 id="main-activity-heading" className="main-activity__title">
              SHOP BY ACTIVITY
            </h2>
            <ul className="main-activity__grid">
              {ACTIVITY_ITEMS.map((item) => (
                <li key={item.label} className="main-activity__cell">
                  <Link
                    onClick={toTop}
                    to="/shop"
                    className="main-activity__card"
                  >
                    <div className="main-activity__thumb">
                      <img
                        src={item.src}
                        alt=""
                        className="main-activity__img"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <span className="main-activity__label">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="main-promo-split" aria-label="Featured collections">
          <div className="main-promo-split__inner">
            {PROMO_SPLIT_ITEMS.map((block) => (
              <article key={block.eyebrow} className="main-promo-split__card">
                <Link
                  onClick={toTop}
                  to={block.to}
                  className="main-promo-split__media-link"
                >
                  <div className="main-promo-split__img-wrap">
                    <img
                      src={block.image}
                      alt=""
                      className="main-promo-split__img"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </Link>
                <div className="main-promo-split__copy">
                  <p className="main-promo-split__eyebrow">{block.eyebrow}</p>
                  <p className="main-promo-split__headline">
                    {block.headlineLines[0]}
                    <br />
                    {block.headlineLines[1]}
                  </p>
                  <Link
                    onClick={toTop}
                    to={block.to}
                    className="main-promo-split__cta"
                  >
                    {block.cta}
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* 6 */}
        <section
          className="main-shop-color"
          aria-labelledby="main-shop-color-heading"
        >
          <div className="main-shop-color__inner">
            <h2 id="main-shop-color-heading" className="main-shop-color__title">
              SHOP BY COLOR
            </h2>
            <div className="main-shop-color__viewport">
              <div
                ref={colorTrackRef}
                className="main-shop-color__track"
                tabIndex={0}
              >
                {COLOR_SHOP_ITEMS.map((item) => (
                  <article key={item.name} className="main-shop-color__card">
                    <Link
                      onClick={toTop}
                      to="/shop"
                      className="main-shop-color__card-link"
                    >
                      <div className="main-shop-color__img-wrap">
                        <img
                          src={item.src}
                          alt=""
                          className="main-shop-color__img"
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                      <div
                        className="main-shop-color__bar"
                        style={{ backgroundColor: item.barBg }}
                      >
                        <p className="main-shop-color__name">{item.name}</p>
                        {item.subtitle ? (
                          <p className="main-shop-color__subtitle">
                            {item.subtitle}
                          </p>
                        ) : null}
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section
          className="main-styled-you"
          aria-labelledby="main-styled-you-heading"
        >
          <div className="main-styled-you__inner">
            <header className="main-styled-you__header">
              <h2
                id="main-styled-you-heading"
                className="main-styled-you__title"
              >
                STYLED BY YOU
              </h2>
              <p className="main-styled-you__sub">
                Click to shop the looks you love!
              </p>
            </header>
            <div className="main-styled-you__viewport">
              <div
                ref={styledTrackRef}
                className="main-styled-you__track"
                tabIndex={0}
              >
                {STYLED_BY_YOU_ITEMS.map((item) => (
                  <article key={item.src} className="main-styled-you__card">
                    <div className="main-styled-you__thumb">
                      <Link
                        onClick={toTop}
                        to="/shop"
                        className="main-styled-you__img-link"
                      >
                        <img
                          src={item.src}
                          alt=""
                          className="main-styled-you__img"
                          loading="lazy"
                          decoding="async"
                        />
                      </Link>
                    </div>
                    <p className="main-styled-you__user">{item.user}</p>
                  </article>
                ))}
              </div>
            </div>
            <button
              type="button"
              className="main-styled-you__to-top"
              onClick={toTop}
              aria-label="Back to top"
            >
              ↑
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
